<template>
  <mgl-geojson-layer :ref="reference" :source-id="sourceId" :source="source" :layer-id="layerId" :layer="layer" @click="clickFunction" />
</template>

<script>
import { MglGeojsonLayer } from 'vue-mapbox'
export default {
  name: 'SegmentationMapLayer',
  components: {
    MglGeojsonLayer,
  },
  props: {
    reference: {
      type: String,
      default: '',
    },
    sourceId: {
      type: String,
      default: '',
    },
    source: {
      type: Object,
      default: () => {},
    },
    layerId: {
      type: String,
      default: '',
    },
    layer: {
      type: Object,
      default: () => {},
    },
    clickFunction: {
      type: Function,
      default: () => {},
    },
  },
  beforeDestroy() {
    this.$emit('clear-clusters')
  },
}
</script>

<style lang="scss" scoped></style>
